<div class="row m-2">
	<div class="col-9">
		<h4>Form J History</h4>
	</div>
	@if (sharedService.isAdmin() == false && sharedService.isBossAccount() == false && sharedService.isAuditor() == false) {
		<div class="col-3 d-flex justify-content-end align-items-right">
			<button class="btn btn-info" (click)="openFormJModal()"><i class="fas fa-plus"></i> New Form J</button>
		</div>
	}
</div>
@if (formJList.length > 0) {
	@if (sharedService.checkFormJExpired(viewCustomer.LastFormJDate) == true) {
		<div class="text-bg-danger fw-bold text-center p-2">You have not generate Form J of this customer for more than 9 months. Please generate Form J.</div>
	}
	<table class="table table-bordered">
		<thead>
			<tr>
				@if (sharedService.isBossAccount()) {
					<th></th>
				}
				<th>Generated Date</th>
				<th>Principal Amount</th>
				<th>Extra Information</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			@for (formJ of formJList; track formJ.Id; let i = $index) {
				<tr>
					@if (sharedService.isBossAccount()) {
						<td>
							@if (formJ.LoanGroupId === undefined) {
								<button class="btn btn-danger" (click)="openDeleteFormJDialog(formJ)"><i class="fas fa-trash-alt"></i></button>
							}
						</td>
					}
					<td>
						{{ formJ.DateCreated | date: 'dd-MM-yyyy' }}
						@if (formJ.LoanGroupId != undefined) {
							<i class="fas fa-money-bill-wave text-info" #tooltip="matTooltip" matTooltip="REQUIRED STAMPED FORM J" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black"></i>
						}
					</td>
					<td>{{ formJ.Principal }}</td>
					<td>
						<table class="table">
							<thead>
								<tr>
									<th>Months</th>
									<th>Amount</th>
								</tr>
							</thead>
							<tbody>
								@for (schedule of formJ.PaymentSchedule; track schedule) {
									<tr>
										<td>{{ schedule.monthsCount }}</td>
										<td>{{ schedule.amount }}</td>
									</tr>
								}
							</tbody>
						</table>
						<p>Terms : {{ formJ.Term }}</p>
						<p>Last Payment: RM {{ formJ.LastPayment }}</p>
						<p>Receipt Number: {{ formJ.ReceiptNumber }}</p>
						<p>Form J Date: {{ formJ.Date | date: 'dd-MM-yyyy' }}</p>
						<p>Version: {{ formJ.Version }}</p>
						<p>Scheme: {{ formJ.Scheme }}</p>
						<p>Stamped Date: {{ formJ.DateStamped | date: 'dd-MM-yyyy' }}</p>
					</td>
					<td class="w-auto">
						<button class="btn btn-outline-dark d-block mb-1" (click)="reprintFormJ(formJ.Id)"><i class="fas fa-print"></i> Reprint</button>
						<button class="btn d-block mb-1" [ngClass]="formJ.LoanGroupId != undefined ? 'btn-info' : 'btn-secondary'" (click)="uploadStampedFormJ(formJ)"><i class="fas fa-file-upload"></i> Upload Stamped Form J</button>
						@if (formJWithFileList?.includes(formJ.Id)) {
							<button class="btn btn-dark d-block mb-1" (click)="viewFormJFiles(formJ.Id)"><i class="fas fa-file-signature"></i> View Form J files</button>
						}
						@if (formJ.DateStamped != undefined && this.sharedService.isBossAccount()) {
							<button class="btn btn-danger d-block" (click)="openUnstampDialog(formJ)"><i class="fas fa-stamp"></i>Unstamp Form J</button>
						}

						@if (formJ.DoccusealLink != undefined && formJ.DoccusealLink != '') {
							@if (formJSigingList != undefined) {
								@if (checkIsSigned(formJ.DocusealId)) {
									<button class="btn btn-outline-success d-block mb-1" (click)="downloadSignedDoc(formJ.Id)"><i class="fas fa-file-download"></i> Download Signed Doc</button>
								} @else {
									<button class="btn btn-outline-primary d-block mb-1" (click)="openSignLink(formJ.DoccusealLink)"><i class="fas fa-file-signature"></i> Copy Sign Link</button>
								}
							}
							<button class="btn btn-outline-danger d-block mb-1" (click)="confirmBeforeDeleteDS(formJ.Id, i)"><i class="fas fa-unlink"></i> Delete Link</button>
						} @else {
							<div class="btn-group">
								<button class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"><i class="fas fa-link"></i> Create Sign Link</button>
								<ul class="dropdown-menu">
									<li (click)="createSignLink(formJ.Id, i, false)" style="cursor: pointer">
										<a class="dropdown-item"> With Date</a>
									</li>
									<li (click)="createSignLink(formJ.Id, i, true)" style="cursor: pointer">
										<a class="dropdown-item">Without Date</a>
									</li>
								</ul>
							</div>
						}
					</td>
				</tr>
			}
		</tbody>
	</table>
} @else {
	<p class="ms-2">You do not have any FORM J record for this customer.</p>
}
